import {
  trainingCollaboratorApi,
  type MemberTrainingStatus,
  type TrainingCollaboratorListItem,
} from '@/entities/Training';
import { useCustomToast } from '@/shared/lib';

const SUCCESS_MESSAGE = 'Status atualizado com sucesso';
const ERROR_MESSAGE = 'Erro ao atualizar status. Tente novamente';

/**
 * Thin wrapper around the status-change endpoint, shared by every table that
 * renders a collaborator's status (the inline trainees table and the paginated
 * Colaboradores tab), so the toast/error handling exists in one place only.
 */
export function useChangeCollaboratorStatus() {
  const { showSuccessToast, showErrorToast } = useCustomToast();

  async function changeStatus(
    trainingId: number,
    collaboratorId: number,
    status: MemberTrainingStatus
  ): Promise<TrainingCollaboratorListItem | null> {
    try {
      const updated = await trainingCollaboratorApi.updateCollaboratorStatus(
        trainingId,
        collaboratorId,
        status
      );
      showSuccessToast({ title: SUCCESS_MESSAGE, type: 'success' });
      return updated;
    } catch {
      showErrorToast({ title: ERROR_MESSAGE, type: 'error' });
      return null;
    }
  }

  return { changeStatus };
}
